import { render } from "./MasterCreateForm.vue?vue&type=template&id=4fc8bda0&scoped=true"
import script from "./MasterCreateForm.vue?vue&type=script&lang=js"
export * from "./MasterCreateForm.vue?vue&type=script&lang=js"

import "./MasterCreateForm.vue?vue&type=style&index=0&id=4fc8bda0&scoped=true&lang=css"

import exportComponent from "/Users/mae/Dev/mamp/htdocs/mfj_renewal/manage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc8bda0"]])

export default __exports__